import React from "react";

import { ApiGufGufsListRequest } from "@nens/brostar/openapi-client";

import { SearchBox } from "@/components/searchbox";

import { gufInformation } from "../types";

type Props = {
  searchField: keyof ApiGufGufsListRequest;
  setSearchField: (searchField: keyof ApiGufGufsListRequest) => void;
  searchString: string;
  setSearchString: (searchString: string) => void;
};

const GufFilters: React.FC<Props> = ({
  searchField,
  setSearchField,
  searchString,
  setSearchString,
}) => {
  return (
    <SearchBox
      searchField={searchField}
      setSearchField={setSearchField}
      searchString={searchString}
      setSearchString={setSearchString}
      searchOptions={gufInformation}
    />
  );
};

export { GufFilters };
